// ============================================================
// 阴盘奇门遁甲（道家转盘时家体系）— 核心常量
// 结构：地盘（三奇六仪）· 天盘（九星携干）· 人盘（八门）· 神盘（八神）
// ============================================================

// 十天干 / 十二地支
export const GAN = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
export const ZHI = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];

// 五行
export const WX = {
  甲: '木', 乙: '木', 丙: '火', 丁: '火', 戊: '土', 己: '土', 庚: '金', 辛: '金', 壬: '水', 癸: '水',
  子: '水', 丑: '土', 寅: '木', 卯: '木', 辰: '土', 巳: '火', 午: '火', 未: '土', 申: '金', 酉: '金', 戌: '土', 亥: '水',
};

// 九宫：洛书 1..9
// 坎1水/北 · 坤2土/西南 · 震3木/东 · 巽4木/东南 · 中5土/中 · 乾6金/西北 · 兑7金/西 · 艮8土/东北 · 离9火/南
export const GONGS = [
  { num: 1, gua: '坎', wx: '水', dir: '北',   zhis: ['子'] },
  { num: 2, gua: '坤', wx: '土', dir: '西南', zhis: ['未', '申'] },
  { num: 3, gua: '震', wx: '木', dir: '东',   zhis: ['卯'] },
  { num: 4, gua: '巽', wx: '木', dir: '东南', zhis: ['辰', '巳'] },
  { num: 5, gua: '中', wx: '土', dir: '中',   zhis: [] },
  { num: 6, gua: '乾', wx: '金', dir: '西北', zhis: ['戌', '亥'] },
  { num: 7, gua: '兑', wx: '金', dir: '西',   zhis: ['酉'] },
  { num: 8, gua: '艮', wx: '土', dir: '东北', zhis: ['丑', '寅'] },
  { num: 9, gua: '离', wx: '火', dir: '南',   zhis: ['午'] },
];
export const GONG_BY_NUM = Object.fromEntries(GONGS.map(g => [g.num, g]));

// ★ 转盘环序（顺时针）：北→东北→东→东南→南→西南→西→西北
// 天盘九星、人盘八门、神盘八神皆沿此环整体旋转，绝不飞越中宫。
export const RING_CW = [1, 8, 3, 4, 9, 2, 7, 6];

// 九星（本宫 + 五行 + 吉凶）。蓬芮冲辅禽心柱任英
export const STARS = [
  { name: '天蓬', ben: 1, wx: '水', luck: '凶' },
  { name: '天芮', ben: 2, wx: '土', luck: '凶' },
  { name: '天冲', ben: 3, wx: '木', luck: '平' },
  { name: '天辅', ben: 4, wx: '木', luck: '吉' },
  { name: '天禽', ben: 5, wx: '土', luck: '吉' },
  { name: '天心', ben: 6, wx: '金', luck: '吉' },
  { name: '天柱', ben: 7, wx: '金', luck: '凶' },
  { name: '天任', ben: 8, wx: '土', luck: '吉' },
  { name: '天英', ben: 9, wx: '火', luck: '平' },
];
export const STAR_BY_BEN = Object.fromEntries(STARS.map(s => [s.ben, s]));
export const STAR_BY_NAME = Object.fromEntries(STARS.map(s => [s.name, s]));

// 八门（本宫 + 五行 + 吉凶）。
// 注意：杜门居巽四宫，五行属【木】（原代码误标为水，已纠正）。
export const MENS = [
  { name: '休门', ben: 1, wx: '水', luck: '吉' },
  { name: '死门', ben: 2, wx: '土', luck: '凶' },
  { name: '伤门', ben: 3, wx: '木', luck: '凶' },
  { name: '杜门', ben: 4, wx: '木', luck: '平' },
  { name: '开门', ben: 6, wx: '金', luck: '吉' },
  { name: '惊门', ben: 7, wx: '金', luck: '凶' },
  { name: '生门', ben: 8, wx: '土', luck: '吉' },
  { name: '景门', ben: 9, wx: '火', luck: '平' },
];
export const MEN_BY_BEN = Object.fromEntries(MENS.map(m => [m.ben, m]));
export const MEN_BY_NAME = Object.fromEntries(MENS.map(m => [m.name, m]));

// 八门的固定环位序：与 RING_CW 一一对应
// 环0(坎1北)=休 · 环1(艮8东北)=生 · 环2(震3东)=伤 · 环3(巽4东南)=杜
// 环4(离9南)=景 · 环5(坤2西南)=死 · 环6(兑7西)=惊 · 环7(乾6西北)=开
export const MEN_RING = ['休门', '生门', '伤门', '杜门', '景门', '死门', '惊门', '开门'];

// 八神（阴盘顺序）。阴盘奇门神盘不分阴阳遁，自值符宫起一律顺时针布；
// 传统阳盘则为阳遁顺时针、阴遁逆时针（UI 可切换对照）。
export const GODS = ['值符', '螣蛇', '太阴', '六合', '白虎', '玄武', '九地', '九天'];
export const SHEN_LUCK = {
  值符: '吉', 太阴: '吉', 六合: '吉', 九地: '吉', 九天: '吉', 太常: '吉',
  螣蛇: '凶', 白虎: '凶', 玄武: '凶',
};

// 三奇六仪布盘序列：戊己庚辛壬癸丁丙乙
export const SANQI_LIUYI = ['戊', '己', '庚', '辛', '壬', '癸', '丁', '丙', '乙'];

// 六甲 → 遁仪
export const LIUJIA_YI = { 甲子: '戊', 甲戌: '己', 甲申: '庚', 甲午: '辛', 甲辰: '壬', 甲寅: '癸' };

// 六仪击刑宫：
// 甲子戊刑在卯(震3) · 甲戌己刑在未(坤2) · 甲申庚刑在寅(艮8)
// 甲午辛午自刑(离9) · 甲辰壬辰自刑(巽4) · 甲寅癸刑在巳(巽4)
export const JIXING = { 戊: 3, 己: 2, 庚: 8, 辛: 9, 壬: 4, 癸: 4 };

// 十干入墓宫（按五行墓库：木库未坤2 · 火库戌乾6 · 金库丑艮8 · 水库辰巽4；戊墓戌、己墓辰）
export const RUMU = {
  甲: 2, 乙: 2, 丙: 6, 丁: 6, 戊: 6, 己: 4, 庚: 8, 辛: 8, 壬: 4, 癸: 4,
};
// 门/星 入墓按五行库
export const RUMU_BY_WX = { 木: 2, 火: 6, 金: 8, 水: 4, 土: 4 };

// 节气 → [阴阳遁, 上元局, 中元局, 下元局]
// 歌诀：冬至一七四 小寒二八五 大寒三九六 / 立春八五二 雨水九六三 惊蛰一七四 清明四一七 立夏四一七 芒种六三九…
export const JIEQI_JU = {
  冬至: ['阳', 1, 7, 4], 小寒: ['阳', 2, 8, 5], 大寒: ['阳', 3, 9, 6],
  立春: ['阳', 8, 5, 2], 雨水: ['阳', 9, 6, 3], 惊蛰: ['阳', 1, 7, 4],
  春分: ['阳', 3, 9, 6], 清明: ['阳', 4, 1, 7], 谷雨: ['阳', 5, 2, 8],
  立夏: ['阳', 4, 1, 7], 小满: ['阳', 5, 2, 8], 芒种: ['阳', 6, 3, 9],
  夏至: ['阴', 9, 3, 6], 小暑: ['阴', 8, 2, 5], 大暑: ['阴', 7, 1, 4],
  立秋: ['阴', 2, 5, 8], 处暑: ['阴', 1, 4, 7], 白露: ['阴', 9, 3, 6],
  秋分: ['阴', 7, 1, 4], 寒露: ['阴', 6, 9, 3], 霜降: ['阴', 5, 8, 2],
  立冬: ['阴', 6, 9, 3], 小雪: ['阴', 5, 8, 2], 大雪: ['阴', 4, 7, 1],
};

// 数字节序（仅供地盘布仪、值使飞宫使用——这两处才走九宫数字）
export const SHUN = [1, 2, 3, 4, 5, 6, 7, 8, 9];
export const NI = [9, 8, 7, 6, 5, 4, 3, 2, 1];

// 驿马（三合冲马）：申子辰马在寅 · 寅午戌马在申 · 巳酉丑马在亥 · 亥卯未马在巳
export const YIMA = {
  子: '寅', 申: '寅', 辰: '寅',
  寅: '申', 午: '申', 戌: '申',
  巳: '亥', 酉: '亥', 丑: '亥',
  亥: '巳', 卯: '巳', 未: '巳',
};

// 地支 → 本宫
export const ZHI_GONG = { 子: 1, 丑: 8, 寅: 8, 卯: 3, 辰: 4, 巳: 4, 午: 9, 未: 2, 申: 2, 酉: 7, 戌: 6, 亥: 6 };
